import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class FetchPrivacyMdFileUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute(locale: string) {
    return this.repo.fetchPrivayMdFile(locale);
  }
}
